module.exports = "/packs/images/svg/ireland/facilities/cafe~6d74ed2413105e5fa3691951c0d35c2e.svg";